import React from 'react'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'

export default function ScheduleSlotRefreshPipes ({ slotId }) {
  return (
    <>
      <ExecuteOperationOnPipe
        resourceName='shifts.schedule_slot'
        operationName='read'
        routeParameters={{ schedule_slot: slotId }}
        operationContext={{ schedule_slot: slotId }}
      />
      <ExecuteOperationOnPipe
        resourceName='shifts.schedule_slot'
        operationName='read'
        routeParameters={{ schedule_slot: slotId }}
        operationContext={{ proxy: true, schedule_slot: slotId }}
      />
    </>
  )
}
